const local = {
  API: {
    AUTH: 'https://localhost:44396/api',
    DATA: 'https://localhost:44396/api'
    }, 
    ORIGINS: ['http://localhost:3000']
}

const dev = {
  API: {
        AUTH: 'https://localhost:44396/api',
        DATA: 'https://localhost:44396/api'
    }, 
    ORIGINS: [
        'http://localhost:3000',
        'https://app.lowquotes.ie',
        'https://hello.lowquotes.ie',
        'https://www.lowquotes.ie',
        'https://www.hello.ie'
    ]
}

const uat = {
  API: {
        AUTH: 'https://qms-api-uat.azurewebsites.net/api',
        DATA: 'https://qms-api-uat.azurewebsites.net/api'
    },
    ORIGINS: [
        'https://staging.lowquotes.ie',
        'https://lowquotes.ie',
        'https://www.lowquotes.ie',
        'https://app.lowquotes.ie',
        'https://app.lowquotes.ie/services',
        'https://hello.lowquotes.ie',
        'https://hello.ie',
        'https://www.hello.ie',
        'https://low.ie',
        'https://www.low.ie',
        'https://truewealth.ie'
    ]
}

const prod = {
  API: {
        AUTH: 'https://qms-api-live.azurewebsites.net/api',
        DATA: 'https://qms-api-live.azurewebsites.net/api'
    },
    ORIGINS: [
        'https://lowquotes.ie',
        'https://www.lowquotes.ie',
        'https://low.ie',
        'https://www.low.ie',
        'https://app.lowquotes.ie',
        'https://hello.lowquotes.ie',
        'https://truewealth.ie',
        'http://hello.ie',
        'https://hello.ie',
        'https://www.hello.ie',
        'http://sitepreviewer.ie',
        'https://sitepreviewer.ie',
        'https://0joqgia.sitepreviewer.ie'
    ]
}

const config = process.env.REACT_APP_STAGE === 'prod' ? prod
  : process.env.REACT_APP_STAGE === 'uat' ? uat
    : process.env.REACT_APP_STAGE === 'dev' ? dev
      : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;

export { API_URL, AUTH_URL };
export default config;
